<template>
  <button
    class="control-button"
    :class="{ 'control-button--active': player.isEcoMode.value }"
    :aria-label="player.isEcoMode.value ? t('player.controls.ecoModeOn') : t('player.controls.ecoModeOff')"
    :data-tooltip="player.isEcoMode.value ? t('player.controls.ecoModeOn') : t('player.controls.ecoModeOff')"
    @click="player.toggleEcoMode()"
    v-html="ecoIcon"
  />
</template>

<script setup lang="ts">
import { ecoIcon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'

defineProps<{
  player: UseVideoPlayerReturn
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
.control-button--active {
  background: var(--vp-primary-color, #007bff) !important;
  color: var(--vp-primary-ink, #fff) !important;
}
</style>
